import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdUserImportsImportIdTransformColumnMappingCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_group_id/user_imports/:import_id",
];
